<template>
  <IncomeConfirm
    top-page-id="en017"
    previous-page-id="en018"
    next-page-id="tem022"
  ></IncomeConfirm>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IncomeConfirm from "@/components/fileupload/IncomeConfirm";

export default {
  name: "En019",
  components: {
    IncomeConfirm,
  },
  setup() {
    setMeta({
      title: "収入証明書のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,書類提出,収入証明",
    });
  },
};
</script>

<style lang="scss" scoped></style>
